<template>
  <embeddable-footer home-url="https://www.icij.org/investigations/luanda-leaks" title="Luanda Leaks" class="embed_footer" :sharing-options-values="sharingOptionsValues" />
</template>


<script>

  import {EmbeddableFooter} from '@icij/murmur'

  export default {
    name: "footerStory",
    components: {
      EmbeddableFooter
    },
    props: {
      url: String,
      card: Object
    },
    computed: {
      urlEmbed() {
        return this.url + "?format_story=embed&slide_story=" + this.card.id
      },
      urlShare() {
        return this.url + "?slide_story=" + this.card.id
      },
      readMore() {
      return this.card.desc_widget ? this.card.desc_widget : "Read our investigation"
      },
      titleCard() {
        return this.card.title_widget ? this.card.title_widget : this.card.title
      },
      media() {
        if(this.card.imgHeader)
          return require("../assets/"+this.card.imgHeader)
        else if(this.card.headerSticky)
          return require("../assets/"+this.card.headerSticky)
        if(this.card.bgImage)
          return require("../assets/"+this.card.bgImage)
        if(this.card.imgFooter)
          return require("../assets/"+this.card.imgFooter)
        if(this.card.imgIcon)
          return require("../assets/"+this.card.imgIcon)
      },
      sharingOptionsValues() {
        return {
            'url': this.urlShare,
            'title': this.titleCard,
            'description': this.readMore,
            'facebook_title': this.titleCard,
            'facebook_description': this.readMore,
            'facebook_media': this.media,
            'twitter_media': this.media,
            'twitter_user': 'icijorg'
          }
      }
    }
  }

</script>

<style lang="scss">
  .embeddable-footer__brand {
    border: none !important;
    cursor: pointer;
  }
</style>